module.exports = __webpack_public_path__ + "static/media/EBIT-BRL.c49541a2.svg";